// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.timeline, .timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before, .timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #F4B41A;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
.text-original-blue{
    color: #2a81bb
}
.text-original-dark-blue{
    color: #143D59
}
.text-original-yellow{
    color: #F4B41A
}

.text-black{
    color: #000000
}

#carouselExampleCaptions{
  width: 720px;
}


#map {
   width: 100%;
   height: 400px;
   background-color: grey;
 }
.map-responsive{
    overflow:hidden;
    padding-bottom:360px;
    margin-bottom:10px;
    position:relative;
    height:0;
}
.map-responsive iframe{
    left:0;
    top:0;
    border: 0px;
    height:360px;
    width:100%;
    position:absolute;
}

.copyright {
    color: #646464 !important;
    font-size: 12px;
}

/*
143D59 - azul escuro

4ca392 - Original

100%         #ffffff
95%          #eef6f5
90%          #ddeeeb    ***
85%          #cce5e1
80%          #bbddd7
75%          #aad4cd
70%          #99ccc2
65%          #88c3b8
60%          #77bbae
55%          #66b2a4
50%          #55aa9a
45%          #4d998b    ***
40%          #44887b
35%          #3c776c
30%          #33665c
25%          #2b554d
20%          #22443e
15%          #1a332e
10%          #11221f
05%          #09110f
00%          #000000




100%         #ffffff
95%          #eaf4fa
90%          #d5e9f6    *********
85%          #c1def1
80%          #acd2ec
75%          #97c7e7
70%          #82bce3
65%          #6eb1de
60%          #59a6d9
55%          #449bd5
50%          #2f90d0
45%          #2a81bb    ******
40%          #2673a6
35%          #216491
30%          #1c567d
25%          #184868
21%          #143d59
20%          #133953
15%          #0e2b3e
10%          #091d2a
5%       #050e15
0%       #000000

*/




/*
.btn-success {
    color: #fff;
    background-color: #4ca392;
    border-color: #4ca392;
}
.btn-success:hover {
    color: #fff;
    background-color: #143D59;
    border-color: #22443e;
}
.btn-success.focus,
.btn-success:focus {
    color: #fff;
    background-color: #143D59;
    border-color: #22443e;
    box-shadow: 0 0 0 0.2rem rgba(77, 153, 139, 0.5);
}
.btn-success.disabled,
.btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}
.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #11221f;
    border-color: #11221f;
}
.btn-success:not(:disabled):not(.disabled).active:focus,
.btn-success:not(:disabled):not(.disabled):active:focus,
.show > .btn-success.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(77, 153, 139, 0.5);
}

*/
.section-title, h2 {
    content: 'xx';
    width: 30px;
    /*height: 3px;*/
    padding-bottom: 10px;
    border: 0;
    border-bottom: 3px solid #F4B41A;
    left: calc(50% - 25px);
    color: #143D59;
}


/*******************************/
/* Navar -- Barra de navegacao */
/*******************************/
.navbar{
  background-color:  #143D59;
}
/*ul.navbar-nav{
  border: 3px solid red;
}
*/
a.nav-item{
    padding-left: 7px;
    padding-right: 7px;
} 

ul.navbar-nav {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.navbar-nav>li {
    display: inline-block;
    margin-left: 20px;
}

.navbar-nav>li>a, a.navbar-link {
    text-decoration: none;
    color: #fef7e7!important; /*verde claro*/
}
.navbar-nav>li>a:hover, a.navbar-link:hover {
    text-decoration: none;
    color: #f6be3c!important; /*verde escuro*/ 
}
.navbar-nav>li>a i {
    margin-right: 10px;
}

/***********************/
/* Header -- Cabecalho */
/***********************/
header{
    color: white;
    /*background-color: #bbddd700;*/

    /*background-size: 50%;*/
    /*background-repeat: repeat;*/
    /*background-attachment: fixed;*/
    /*height: 800px;*/

    height: 100%;
    background-color: #143D59;
/*    background-image: url("../img/samira-thin.jpg");
    background-position: center center;
*/


    margin-top: 64px;
   background-size: cover;
   -o-background-size: cover;

}

.message {
    width: 50%;
    height: auto;
    margin: 100px auto 50px auto;
    padding: 40px;
    background-color: #F4B41Acc;
    border-radius: 15px;
    position:relative;
}

.img-fluid-test{
  width:320px;
}


@media screen and (max-width: 768px) {
    .message {
        width: 70%;
        /*max-height: 70%;*/
        padding: 35px;
    }
    /*.container {
        margin-top: 30px;
    }*/
    header{
        height: 100%;
    }
    h1.display-4{
      font-size: 30px;
      font-weight: normal;
    }
    p.lead{
      font-size: 14px;
      font-weight: normal;
    }
    p.info{
      margin-top: 200px;
    }
    .imagem{
      width: 60px;
    }
  .img-fluid-test{
    width:0px;
    display: inline-block;
  }
}

@media screen and (max-width: 650px) {
    .message {
        width: 70%;
        /*max-height: 70%;*/
        padding: 15px;
    }
    header{
        height: 100%;
    }
    h1.display-4{
      font-size: 30px;
      font-weight: normal;
    }
    p.lead{
      font-size: 14px;
      font-weight: normal;
    }
    p.info{
      margin-top: 200px;
    }
    .imagem{
      width: 0px;
    }

  .img-fluid-test{
    width:0px;
  }
}

ul.no-bullet {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.zoom {
  /*padding: 50px;*/
  transition: transform .2s; /* Animation */
  /*margin: 0 auto;*/
}

.zoom:hover {
  transform: scale(1.03); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  border: 3px solid #F4B41A;
}
.img-fluid{
display: block;
}

`, "",{"version":3,"sources":["webpack://./src/css/timeline.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;EACE,YAAY;AACd;;;AAGA;GACG,WAAW;GACX,aAAa;GACb,sBAAsB;CACxB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;AACZ;AACA;IACI,MAAM;IACN,KAAK;IACL,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAqDC;;;;;AAKD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAqCC;AACD;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,cAAc;AAClB;;;AAGA,gCAAgC;AAChC,gCAAgC;AAChC,gCAAgC;AAChC;EACE,0BAA0B;AAC5B;AACA;;;CAGC;AACD;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB,EAAE,cAAc;AAC5C;AACA;IACI,qBAAqB;IACrB,wBAAwB,EAAE,eAAe;AAC7C;AACA;IACI,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;IACI,YAAY;IACZ,+BAA+B;;IAE/B,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;IAChC,iBAAiB;;IAEjB,YAAY;IACZ,yBAAyB;AAC7B;;CAEC;;;IAGG,gBAAgB;GAMjB,sBAAsB;GACtB,yBAAyB;;AAE5B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,WAAW;AACb;;;AAGA;IACI;QACI,UAAU;QACV,mBAAmB;QACnB,aAAa;IACjB;IACA;;MAEE;IACF;QACI,YAAY;IAChB;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,WAAW;IACb;EACF;IACE,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,UAAU;IACZ;;EAEF;IACE,SAAS;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,cAAc;EACzC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB,EAAE,qFAAqF;EAC7G,yBAAyB;AAC3B;AACA;AACA,cAAc;AACd","sourcesContent":["ul.timeline, .timeline {\n    list-style-type: none;\n    position: relative;\n}\nul.timeline:before, .timeline:before {\n    content: ' ';\n    background: #d4d9df;\n    display: inline-block;\n    position: absolute;\n    left: 29px;\n    width: 2px;\n    height: 100%;\n    z-index: 400;\n}\nul.timeline > li {\n    margin: 20px 0;\n    padding-left: 20px;\n}\nul.timeline > li:before {\n    content: ' ';\n    background: white;\n    display: inline-block;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #F4B41A;\n    left: 20px;\n    width: 20px;\n    height: 20px;\n    z-index: 400;\n}\n.text-original-blue{\n    color: #2a81bb\n}\n.text-original-dark-blue{\n    color: #143D59\n}\n.text-original-yellow{\n    color: #F4B41A\n}\n\n.text-black{\n    color: #000000\n}\n\n#carouselExampleCaptions{\n  width: 720px;\n}\n\n\n#map {\n   width: 100%;\n   height: 400px;\n   background-color: grey;\n }\n.map-responsive{\n    overflow:hidden;\n    padding-bottom:360px;\n    margin-bottom:10px;\n    position:relative;\n    height:0;\n}\n.map-responsive iframe{\n    left:0;\n    top:0;\n    border: 0px;\n    height:360px;\n    width:100%;\n    position:absolute;\n}\n\n.copyright {\n    color: #646464 !important;\n    font-size: 12px;\n}\n\n/*\n143D59 - azul escuro\n\n4ca392 - Original\n\n100%         #ffffff\n95%          #eef6f5\n90%          #ddeeeb    ***\n85%          #cce5e1\n80%          #bbddd7\n75%          #aad4cd\n70%          #99ccc2\n65%          #88c3b8\n60%          #77bbae\n55%          #66b2a4\n50%          #55aa9a\n45%          #4d998b    ***\n40%          #44887b\n35%          #3c776c\n30%          #33665c\n25%          #2b554d\n20%          #22443e\n15%          #1a332e\n10%          #11221f\n05%          #09110f\n00%          #000000\n\n\n\n\n100%         #ffffff\n95%          #eaf4fa\n90%          #d5e9f6    *********\n85%          #c1def1\n80%          #acd2ec\n75%          #97c7e7\n70%          #82bce3\n65%          #6eb1de\n60%          #59a6d9\n55%          #449bd5\n50%          #2f90d0\n45%          #2a81bb    ******\n40%          #2673a6\n35%          #216491\n30%          #1c567d\n25%          #184868\n21%          #143d59\n20%          #133953\n15%          #0e2b3e\n10%          #091d2a\n5%       #050e15\n0%       #000000\n\n*/\n\n\n\n\n/*\n.btn-success {\n    color: #fff;\n    background-color: #4ca392;\n    border-color: #4ca392;\n}\n.btn-success:hover {\n    color: #fff;\n    background-color: #143D59;\n    border-color: #22443e;\n}\n.btn-success.focus,\n.btn-success:focus {\n    color: #fff;\n    background-color: #143D59;\n    border-color: #22443e;\n    box-shadow: 0 0 0 0.2rem rgba(77, 153, 139, 0.5);\n}\n.btn-success.disabled,\n.btn-success:disabled {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n}\n.btn-success:not(:disabled):not(.disabled).active,\n.btn-success:not(:disabled):not(.disabled):active,\n.show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #11221f;\n    border-color: #11221f;\n}\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(77, 153, 139, 0.5);\n}\n\n*/\n.section-title, h2 {\n    content: 'xx';\n    width: 30px;\n    /*height: 3px;*/\n    padding-bottom: 10px;\n    border: 0;\n    border-bottom: 3px solid #F4B41A;\n    left: calc(50% - 25px);\n    color: #143D59;\n}\n\n\n/*******************************/\n/* Navar -- Barra de navegacao */\n/*******************************/\n.navbar{\n  background-color:  #143D59;\n}\n/*ul.navbar-nav{\n  border: 3px solid red;\n}\n*/\na.nav-item{\n    padding-left: 7px;\n    padding-right: 7px;\n} \n\nul.navbar-nav {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n.navbar-nav>li {\n    display: inline-block;\n    margin-left: 20px;\n}\n\n.navbar-nav>li>a, a.navbar-link {\n    text-decoration: none;\n    color: #fef7e7!important; /*verde claro*/\n}\n.navbar-nav>li>a:hover, a.navbar-link:hover {\n    text-decoration: none;\n    color: #f6be3c!important; /*verde escuro*/ \n}\n.navbar-nav>li>a i {\n    margin-right: 10px;\n}\n\n/***********************/\n/* Header -- Cabecalho */\n/***********************/\nheader{\n    color: white;\n    /*background-color: #bbddd700;*/\n\n    /*background-size: 50%;*/\n    /*background-repeat: repeat;*/\n    /*background-attachment: fixed;*/\n    /*height: 800px;*/\n\n    height: 100%;\n    background-color: #143D59;\n/*    background-image: url(\"../img/samira-thin.jpg\");\n    background-position: center center;\n*/\n\n\n    margin-top: 64px; \n\n\n\n   -webkit-background-size: cover;\n   -moz-background-size: cover;\n   background-size: cover;\n   -o-background-size: cover;\n\n}\n\n.message {\n    width: 50%;\n    height: auto;\n    margin: 100px auto 50px auto;\n    padding: 40px;\n    background-color: #F4B41Acc;\n    border-radius: 15px;\n    position:relative;\n}\n\n.img-fluid-test{\n  width:320px;\n}\n\n\n@media screen and (max-width: 768px) {\n    .message {\n        width: 70%;\n        /*max-height: 70%;*/\n        padding: 35px;\n    }\n    /*.container {\n        margin-top: 30px;\n    }*/\n    header{\n        height: 100%;\n    }\n    h1.display-4{\n      font-size: 30px;\n      font-weight: normal;\n    }\n    p.lead{\n      font-size: 14px;\n      font-weight: normal;\n    }\n    p.info{\n      margin-top: 200px;\n    }\n    .imagem{\n      width: 60px;\n    }\n  .img-fluid-test{\n    width:0px;\n    display: inline-block;\n  }\n}\n\n@media screen and (max-width: 650px) {\n    .message {\n        width: 70%;\n        /*max-height: 70%;*/\n        padding: 15px;\n    }\n    header{\n        height: 100%;\n    }\n    h1.display-4{\n      font-size: 30px;\n      font-weight: normal;\n    }\n    p.lead{\n      font-size: 14px;\n      font-weight: normal;\n    }\n    p.info{\n      margin-top: 200px;\n    }\n    .imagem{\n      width: 0px;\n    }\n\n  .img-fluid-test{\n    width:0px;\n  }\n}\n\nul.no-bullet {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.zoom {\n  /*padding: 50px;*/\n  transition: transform .2s; /* Animation */\n  /*margin: 0 auto;*/\n}\n\n.zoom:hover {\n  transform: scale(1.03); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n  border: 3px solid #F4B41A;\n}\n.img-fluid{\ndisplay: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
